import { useState, useRef, useContext } from 'react';
import {
  Box, 
  Fab,
  Menu,
  IconButton,
  Tooltip
} from '@mui/material';

import { styled } from '@mui/system';

import {
  Edit as EditIcon,
  Add as AddIcon,
} from '@mui/icons-material';

import { 
  BrandModal,
  CategoryModal,
  PriceInfoModal,
  PriceModal,
  RetailPriceModal,
  MarkupModal,
  QuantityModal,
  DeliveryModal,
  CommitedModal,
  ReceivedModal,
  NoteModal,
  OrderNumberModal,

  CopyModal,
  DeleteModal,
  MoveModal,
  MergeModal,
  PrintModal,
  ShopifyImportModal,
} from './BulkEditModals'

import { Product, AuthContext } from 'components'

export const stopPropagationForTab = (event) => {
  event.stopPropagation();
};


export const FloatingActionButtons = (props) => {
  const { items, selected, createProduct } = props // table.current.getRow(item)
  const { accountIntegrations, account } = useContext(AuthContext);

  const [anchorEl, setAnchorEl] = useState(null);
  const editButtonRef = useRef();
  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    // setAnchorEl(event.target);
    setAnchorEl(editButtonRef.current);
  };

  const handleClose = () => {
    setTimeout(() => {
      setAnchorEl(null)
    }, 15);
  };

  const box_style = {
    width: 'auto',
    textAlign: 'center',
    border: '1px solid #D5D5D5',
    borderRadius: '35px',
    margin: '0 auto',
    padding: '5px',
    display: 'inline-block',
    '& > :not(style)': { m: 1 },
  }

  const wrapper_style = { 
    zIndex: 999,
    textAlign: 'center', 
    position: 'fixed', 
    left: 0,
    bottom: 30,
    width: '100%',
    marginLeft: 0
  }

  return (
    <Box sx={wrapper_style}>
      <Box sx={box_style}>
        <Fab disableRipple component="div" color="secondary" aria-label="add">
          <Tooltip title="Add Product" placement='bottom' slotProps={{ popper: { modifiers: [ { name: 'offset', options: { offset: [0, 10] } } ] } }}>
            <span>
              <IconButton onClick={createProduct}>
                <AddIcon sx={{color: 'white'}} />
              </IconButton>
            </span>
          </Tooltip>
        </Fab>
        <Tooltip title="Move" placement='bottom' slotProps={{ popper: { modifiers: [ { name: 'offset', options: { offset: [0, 10] } } ] } }}>
          <span style={{ margin: 0, marginLeft: 5 }}>
            <MoveModal selected={selected} items={items} />
          </span>
        </Tooltip>
        <Tooltip title="Mark Received" placement='bottom' slotProps={{ popper: { modifiers: [ { name: 'offset', options: { offset: [0, 10] } } ] } }}>
          <span style={{ margin: 0, marginLeft: 5 }}>
            <ReceivedModal selected={selected} items={items}/>
          </span>
        </Tooltip>
        {account?.features?.shopify && Object.keys(accountIntegrations?.shopify_v2||{}).length > 0? (
          <span style={{ margin: 0, marginLeft: 5 }}>
            <ShopifyImportModal selected={selected} items={items} onClose={handleClose} />
          </span>
        ) : null}
        <Fab disableRipple className="gallery" component="div" disabled={!selected} color="secondary" aria-label="edit" variant="extended" onClick={handleClick}>
          <EditIcon ref={editButtonRef} />
          Bulk edit
          <Menu
            id="basic-menu"
            anchorEl={anchorEl}
            open={open}
            onClose={handleClose}
            anchorOrigin={{
              vertical: 'top',
              horizontal: 'right',
            }}
            transformOrigin={{
              vertical: 'bottom',
              horizontal: 'left',
            }}
            MenuListProps={{
              'aria-labelledby': 'basic-button',
            }}
          >
            <BrandModal onClose={handleClose} items={items}/>
            <CategoryModal onClose={handleClose} items={items}/>
            <PriceModal onClose={handleClose} items={items}/>
            <RetailPriceModal onClose={handleClose} items={items}/>
            <MarkupModal onClose={handleClose} items={items}/>
            <PriceInfoModal onClose={handleClose} items={items}/>
            <QuantityModal onClose={handleClose} items={items}/>
            <DeliveryModal onClose={handleClose} items={items}/>
            <OrderNumberModal onClose={handleClose} items={items}/>
            <CommitedModal selected={selected} onClose={handleClose} items={items}/>
            <NoteModal selected={selected} onClose={handleClose} items={items}/>
            <hr/>
            <PrintModal selected={selected} items={items} />
            <CopyModal selected={selected} items={items} />
            <MergeModal selected={selected} items={items} />
            <DeleteModal selected={selected} items={items} />
          </Menu>
        </Fab>
      </Box>
    </Box>
  )
}